import { Routes } from '@angular/router';

import { UnderMaintenanceComponent } from '@shared/components/under-maintenance/under-maintenance.component';
import { NotFoundComponent } from './core/not-found/not-found.component';

export const routes: Routes = [
  { path: 'under-maintenance', component: UnderMaintenanceComponent },
  {
    path: 'referral',
    loadComponent: () =>
      import('@modules/refer/refer-redirect/refer-redirect.component').then(m => m.ReferRedirectComponent),
  },
  {
    path: '',
    loadComponent: () => import('./layouts/user-layout/user-layout.component').then(m => m.UserLayoutComponent),
    loadChildren: () => import('./layouts/user-layout/user-layout.routes').then(mod => mod.USER_LAYOUT_ROUTES),
  },
  { path: '', loadChildren: () => import('@modules/auth/auth.routes').then(m => m.AUTH_ROUTES) },
  { path: 'error', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent },
];
